import { orderBy as _orderBy } from 'lodash';
import type { Action } from '../typings/reducers';
import { getTranslationKey } from '../modules/utils/helpers';

type AdminState = {
  allUsers?: unknown[];
  allUserSites?: unknown[];
  sitesGroupByType?: Array<{ title: string; count: number; percent: number }>;
} & Record<string, unknown>;

export default function (state: AdminState = {}, action: Action): AdminState {
  try {
    switch (action.type) {
      case 'fetch_all_users':
        return { ...state, allUsers: action.payload };
      case 'fetch_all_user_sites':
        return { ...state, allUserSites: action.payload };
      case 'fetch_sites_group_by_type':
        const { groupByType, overallCount } = action.payload;

        let sitesGroupByType = [];
        const others = {
          title: getTranslationKey('adminDashboard.siteTypeStats.others'),
          count: 0,
          percent: 0
        };

        (groupByType as Array<{ _id?: string; count: number }>).forEach((t) => {
          if (t.count < 10 || !t._id) {
            others.count += t.count;
            others.percent = Math.floor((100 / overallCount) * others.count);
          } else {
            sitesGroupByType.push({
              title: t._id as string,
              count: t.count,
              percent: Math.floor((100 / overallCount) * t.count)
            });
          }
        });

        if (others.count > 0) sitesGroupByType.push(others);

        sitesGroupByType = _orderBy(sitesGroupByType, 'count', 'desc');

        return { ...state, sitesGroupByType };
      default:
        return state;
    }
  } catch (e) {
    console.log(e);
  }
}
